import { render, staticRenderFns } from "./tongzhixiangqing.vue?vue&type=template&id=26e6b500&scoped=true"
import script from "./tongzhixiangqing.vue?vue&type=script&lang=js"
export * from "./tongzhixiangqing.vue?vue&type=script&lang=js"
import style0 from "./tongzhixiangqing.vue?vue&type=style&index=0&id=26e6b500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e6b500",
  null
  
)

export default component.exports